import { useAllEdges, useTasksByState } from '@/db/hooks'
import { withSteps } from '@/lib/steps'
import { useListNav } from '@/hooks/useKeyboard'
import { isTemplate } from '@/kinds/task'
import { TaskRow } from '@/components/TaskRow'
import { Button, Empty, PageTitle } from '@/components/ui'
import { Inbox as InboxIcon } from 'lucide-react'
import { useUi } from '@/state/ui'
import { SuggestionsRow } from '@/components/Suggestions'
import { WaitingCaptures, useWaitingCaptures } from '@/components/WaitingCaptures'

export const InboxView = () => {
  // a capture waiting for the owner shows as its card above, not twice
  const carriers = new Set(useWaitingCaptures().map((s) => s.spec.target_id))
  const tasks = (useTasksByState('inbox') ?? [])
    .filter((t) => !isTemplate(t.spec) && !carriers.has(t.id))
    .sort((a, b) => (a.created_at < b.created_at ? 1 : -1))
  const ordered = withSteps(tasks, useAllEdges())
  const cursor = useListNav(ordered.map((x) => x.task.id))
  const setQuickAdd = useUi((s) => s.setQuickAdd)
  return (
    <div>
      <PageTitle>Inbox</PageTitle>
      <WaitingCaptures />
      <SuggestionsRow types={['triage']} />
      {tasks.length === 0 && carriers.size === 0 ? (
        <Empty
          icon={<InboxIcon size={30} strokeWidth={1.5} aria-hidden />}
          action={
            <Button variant="chip" onClick={() => setQuickAdd(true)}>
              Add something
            </Button>
          }
        >
          Inbox is clear. What you capture lands here first.
        </Empty>
      ) : (
        <ul className="group-list" data-testid="inbox-list">
          {ordered.map(({ task: t, child }, i) => (
            <TaskRow key={t.id} task={t} index={i} focused={cursor === i} mode="triage" child={child} />
          ))}
        </ul>
      )}
    </div>
  )
}
